import React from "react";
import { Container, Row } from "reactstrap";

import DetailsSection from "./DetailSection";

const BillDetails = () => {
  document.title = "Job Details";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}

          <Row>
            {/* <Overview /> */}
            <DetailsSection />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BillDetails;
